import * as XLSX from "xlsx";

const normalizeText = (value) => String(value != null ? value : "").trim();

const hasText = (source, target) => {
  return normalizeText(source).indexOf(target) !== -1;
};

export const isHHHNode = (selectedNode) => {
  return (
    normalizeText(selectedNode && selectedNode.nodecode).toUpperCase() === "HHH"
  );
};

export const getHHHHealthInsuranceFromRow = (row) => {
  const rightText = normalizeText(row && row["สิทธิการรักษา"]);
  const rightTextUpper = rightText.toUpperCase();

  if (!rightText) return "";

  if (hasText(rightText, "เงินสด")) {
    return "ชำระเงินเอง";
  }

  if (hasText(rightText, "ประกันสังคม")) {
    return "ประกันสังคม";
  }

  if (
    hasText(rightText, "ข้าราชการระบบจ่ายตรง") ||
    hasText(rightText, "ข้าราชการเบิกต้นสังกัด")
  ) {
    return "กรมบัญชีกลาง";
  }

  if (
    rightTextUpper.indexOf("UC30") !== -1 ||
    rightTextUpper.indexOf("UC WALKIN") !== -1 ||
    hasText(rightText, "ประกันสุขภาพถ้วนหน้า")
  ) {
    return "ประกันสุขภาพถ้วนหน้า";
  }

  return "";
};

const formatYMD = (year, month, day) => {
  let y = parseInt(year, 10);
  const m = parseInt(month, 10);
  const d = parseInt(day, 10);

  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) {
    return "";
  }

  if (y > 2400) {
    y = y - 543;
  }

  const normalized = new Date(Date.UTC(y, m - 1, d));
  if (
    normalized.getUTCFullYear() !== y ||
    normalized.getUTCMonth() !== m - 1 ||
    normalized.getUTCDate() !== d
  ) {
    return "";
  }

  const today = new Date();
  const todayUtc = Date.UTC(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );

  if (normalized.getTime() > todayUtc) {
    return "";
  }

  return `${String(y).padStart(4, "0")}-${String(m).padStart(2, "0")}-${String(
    d,
  ).padStart(2, "0")}`;
};

export const parsePatientImportDateOfBirth = (value, date1904 = false) => {
  if (value === null || value === undefined || value === "") return "";

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return formatYMD(value.getFullYear(), value.getMonth() + 1, value.getDate());
  }

  if (typeof value === "number") {
    const parsed = XLSX.SSF.parse_date_code(value, { date1904 });
    if (parsed) {
      return formatYMD(parsed.y, parsed.m, parsed.d);
    }
  }

  const raw = normalizeText(value);
  if (!raw) return "";

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const parts = raw.split("-");
    return formatYMD(parts[0], parts[1], parts[2]);
  }

  const ymdSlash = raw.match(/^(\d{4})[/](\d{1,2})[/](\d{1,2})$/);
  if (ymdSlash) {
    return formatYMD(ymdSlash[1], ymdSlash[2], ymdSlash[3]);
  }

  const dmy = raw.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (dmy) {
    return formatYMD(dmy[3], dmy[2], dmy[1]);
  }

  return "";
};

export const getPatientImportDateOfBirthFromRow = (row, date1904 = false) => {
  return parsePatientImportDateOfBirth(row && row["DOB"], date1904);
};

// Read workbooks with cellDates: false to preserve date serials without
// timezone conversion. Keep displayed identifiers, but use the full DOB value
// so Excel formats such as m/d/yy cannot discard its century or Buddhist year.
export const getPatientImportRows = (worksheet) => {
  const rows = XLSX.utils.sheet_to_json(worksheet, { defval: "", raw: false });
  const rawRows = XLSX.utils.sheet_to_json(worksheet, { defval: "", raw: true });
  rows.forEach((row, index) => {
    if (Object.prototype.hasOwnProperty.call(rawRows[index], "DOB")) {
      row.DOB = rawRows[index].DOB;
    }
  });
  return rows;
};
